<template>
  <div v-if="mng" id="Order">
     <!-- Catalog -->
      <div v-if="ai===9" class="input-group md-form form-sm form-2 pl-0 mb-3">
        <template v-if="goods.length > 0">
         <div class="input-group-prepend" v-scroll-to="{el:'#' + lastedited,offset: -70}">
             <span class="input-group-text text-white blue" title=""><i class="fa fa-search text-grey" aria-hidden="true" ></i></span>
        </div>
        <input ref="inp" class="form-control" v-bind:class="{'red-text':filteredList.length === 0 && goods.length > 0, 'text-primary':filteredList.length > 100 &&  filteredList.length < goods.length}" v-model.trim="search" type="text" placeholder="Поиск" aria-label="Search" title="Введи ключевые слова в поле поиска">
        <span class="input-group-text text-white red hoverable" title="Очистить поле ввода" @click="search=''" id="basic-text1"><i class="fa fa-times text-grey" aria-hidden="true"></i></span>
      </template>
      </div>
       <badge color="info-color-dark" v-if="loading" v-bind:class="{'animated slow infinite zoomIn':loading}"><i class="fa fa-truck" aria-hidden="true"></i></badge>
       <template v-if="search.length === 0 && goods.length > 0">
       <div v-if="folder1 === '00000000-0000-0000-0000-000000000000' && folder2 === '00000000-0000-0000-0000-000000000000'" class="card-deck">
       </div>
       </template>
        <template v-if="filteredList.length === 0 && goods.length > 0 && search!=''">
       <div class="card col">
        <div class="card-body">
         <blockquote class="blockquote bq-danger">
           <p class="bq-title text-center">Ничего не найдено - папка не содержит товаров или неверный запрос</p>
          </blockquote>
        </div>
      </div>
       </template>
       <div v-if="!loading">
        <div v-for="(good, index) in filteredList" :key="index" class="card md-1 mt-1" :id=calculateid(good.Ref_Key) v-bind:class="{'blue lighten-5' : good.changed === true }">
        <div @click.passive="good.ShowPicture = !good.ShowPicture" v-if="good.ShowPicture" class="view zoom view-cascade view overlay justify-content-md-center">
            <img class="card-img-top img-fluid z-depth-1" :src='good.ФайлКартинки' alt="Фото">
          </div>
        <!-- Card content -->
          <div class="card-body mt-0 md-0">
              <!-- Text -->
                <div class="card-text" v-bind:class="{'black-text' : good.toOrder>0 }">
                <b>   {{good.Артикул}} </b> {{good.Description}}
              </div>
            </div>
             <div class="card-footer d-flex flex-wrap justify-content-end">
                 <div v-if="mng" class="input-group-prepend col" style="cursor: pointer;">
                    <span class="input-group-text success-color-dark text-white" title='На складе в Минске'>{{good.Stock}}</span>
                    <span v-if="good.ВРезерве > 0 " class="input-group-text warning-color-dark text-white" title='В резерве'>{{good.ВРезерве}}</span>
                    <span class="input-group-text default-color text-white"  v-bind:title="transit(good)">{{good.DeliveryQty}}</span>
                    <span class="input-group-text secondary-color-dark text-white" title='На складе поставщика'>{{good.StockS}}</span>
                  </div>
                  <span  style="cursor: pointer;" class="input-group-text text-white" v-bind:class="{'success-color':good.classABCXYZ === 'AX','success-color-dark':good.classABCXYZ === 'AY','default-color':good.classABCXYZ === 'AZ','info-color':good.classABCXYZ === 'BX','primary-color':good.classABCXYZ === 'BY','info-color-dark':good.classABCXYZ === 'BZ','warning-color':good.classABCXYZ === 'CX','warning-color-dark':good.classABCXYZ === 'CY','danger-color':good.classABCXYZ === 'CZ','elegant-color':good.classABCXYZ === 'UU'}" title='Класс товара' >{{good.classABCXYZ}}</span>
                  <button style="cursor: pointer;" @click.prevent="getGoodSales(good.Ref_Key)" class="hoverable input-group-text unique-color-dark text-white" title='Продано за месяц'>{{good.sales30}}</button>
                 <input class="form-control col-3 animated fadeIn" v-bind:class=" {'stock': good.StockS, 'miss': ((good.StockS===0) && (good.DeliveryQty===0)), 'transit':((good.Stock===0) && (good.DeliveryQty>0)), 'supplier' : good.StockS===0 && good.DeliveryQty===0 && good.StockS > 0} " type="number" v-bind:value="good.toOrder" @input="good.toOrder=calculateInput(good,$event)" @keyup="good.toOrder=calculateInput(good,$event)" @mousevent="good.toOrder=calculateInput(good,$event)" aria-label="Количество для заказа, используйте стрелки вверх-вниз для изменения" title="Количество для заказа, используйте стрелки вверх-вниз для изменения">
              </div>
           </div>
          </div>
         <modal size="lg" v-if="showModal" @close="showModal = false">
          <modal-header>
            <modal-title>Движения товара за последние 2 месяца по неделям</modal-title>
          </modal-header>
          <modal-body>
            <mdb-container>
              <mdb-bar-chart :data="barChartData" :options="barChartOptions" :width="600" :height="300"></mdb-bar-chart>
              <div class="d-grid gap-2 d-md-flex flex-fill">
              <div class="btn-group animated slow fadeIn">
                <button style="cursor: pointer;" @click.prevent="getGoodSales(good.Ref_Key)" class="hoverable input-group-text text-white" v-bind:class="{'success-color':goodabc === 'AX','success-color-dark':goodabc === 'AY','default-color':goodabc === 'AZ','info-color':goodabc === 'BX','primary-color':goodabc === 'BY','info-color-dark':goodabc === 'BZ','warning-color':goodabc === 'CX','warning-color-dark':goodabc === 'CY','danger-color':goodabc === 'CZ','elegant-color':goodabc === 'UU'}" title='Класс товара'>{{goodabc}}
                </button>
                <div class="p-1 logo-wrapper animated bounceInDown">
                </div>
              </div>
                 <div class="p-0 flex-grow-1 animated bounceInDown">
                    <p><small>{{orderComment}}</small></p>
                 </div>
              <div class="btn-group animated slow fadeIn" @keydown.esc="showModal = false">
                <button style="cursor: pointer;" class="hoverable input-group-text primary-color text-white" title='На складе'>{{goodstock}}</button>
                <button style="cursor: pointer;" class="hoverable input-group-text default-color text-white" title='В транзите'>{{goodshipment}}</button>
                <button style="cursor: pointer;" class="hoverable input-group-text warning-color-dark text-white" title='В резервах'>{{reserved}}</button>
                <button style="cursor: pointer;" class="hoverable input-group-text success-color text-white" title='Отгружается'>{{goodSelling}}</button>
                <button style="cursor: pointer;" class="hoverable input-group-text info-color text-white" title='Ср. продажи в неделю 2 мес'>{{salesavg60}}</button>
                <button style="cursor: pointer;" class="hoverable input-group-text info-color text-white" v-bind:class=" {'btn-green': (salesavg60 < salesavg30), 'btn-warning': ((salesavg60 > salesavg30))}" title='Ср. продажи в неделю 1 мес'>{{salesavg30}}</button>
                <button style="cursor: pointer;" class="hoverable input-group-text text-white" v-bind:class=" {'btn-green': (goodToOrder > 0), 'btn-danger': ((goodToOrder < 0))}" title='Заказать'>{{goodToOrder}}</button>
              </div>
            </div>
              </mdb-container></modal-body>
          </modal>
         <back-to-top bottom="30px" right="30px">
          <button @click="$refs.inp.focus()" type="button" class="btn  red darken-3 hoverable btn-to-top d-none d-lg-block"><i class="fa fa-chevron-up"></i></button>
        </back-to-top>
    </div>
</template>

<script>
import {Row, Column, Btn, Card, CardBody, CardHeader, CardText, Fa, BarChart, PieChart, LineChart, RadarChart, DoughnutChart, ListGroup, ListGroupItem, Badge, Modal, ModalHeader, ModalTitle, ModalBody, ModalFooter, Carousel, CarouselItem, CarouselCaption, mdbBarChart, mdbContainer} from 'mdbvue'
import ApiService from '@/services/ApiService'
import format from 'date-fns/format'
import subDays from 'date-fns/sub_days'
export default {
  name: 'order',
  components: {
    Row,
    Column,
    Btn,
    Card,
    CardBody,
    CardHeader,
    CardText,
    Fa,
    BarChart,
    PieChart,
    LineChart,
    RadarChart,
    DoughnutChart,
    ListGroup,
    ListGroupItem,
    Badge,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Carousel,
    CarouselItem,
    CarouselCaption,
    mdbBarChart,
    mdbContainer
  },
  props: ['ai', 'goods', 'orders', 'mng', 'folder1', 'folder2', 'orderedOnly', 'selectedSchema', 'supplierOrder', 'orderFilter'],
  data () {
    return {
      lastedited: '',
      loading: false,
      showModal: false,
      results: [],
      goodsabc: [],
      reserves: [],
      shipment: [],
      goodssales60: [],
      goodssales30: [],
      goodSales: [],
      goodBuy: [],
      goodStock: [],
      goodABCXYZ: [],
      goodabc: '',
      goodstock: 0,
      reserved: 0,
      salesavg30: 0,
      salesavg60: 0,
      goodSelling: 0,
      goodshipment: 0,
      goodToOrder: 0,
      goodsales60: 0,
      orderComment: '',
      Transit: [],
      lgoods: [],
      search: '',
      itemsSelected: 0,
      keys: ['Артикул', 'Description'],
      hideSearchTip: false,
      closetags: false,
      inlist: false,
      barChartData: {
        labels: ['8', '7', '6', '5', '4', '3', '2', '1', format(Date(), 'WW'), 'Прогноз'],
        datasets: [
          {
            label: 'Продажи',
            backgroundColor: 'rgba(245, 74, 85, 0.5)',
            data: this.goodSales
          },
          {
            label: 'Остатки',
            backgroundColor: 'rgba(245, 192, 50, 0.5)',
            data: this.goodStock
          },
          {
            label: 'Покупки',
            backgroundColor: 'rgba(90, 173, 246, 0.5)',
            data: this.goodBuy
          }
        ]
      },
      barChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            }
          }]
        }
      }
    }
  },
  mounted () {
    console.log('ORDER MOUNTED')
    window.addEventListener('keydown', this.escCloseModal)
    this.loading = true
    // this.getTransit()
    this.getGoodsABCXYZ()
    this.getGoodsReserves()
    this.getGoodsToShipment()
    this.getGoodsSalesByPeriod30()
    this.getGoodsSalesByPeriod60()
    this.$bus.$on('CreateSupplierOrder', ($event) => {
      console.log('CreateSupplierOrderEvent')
      this.CreateSupplierOrder()
    })
  },
  updated () {
    console.log('updated')
  },
  created () {
  },
  computed: {
    filteredList () {
      return this.goods.filter(good => {
        var keywords = this.search.split(' ')
        var res = false
        var res1 = true
        if (good.toOrder > 0) res = true
        keywords.forEach((element, index) => {
          // console.log(good.Description)
          var str = good.Артикул + ' ' + good.Description + ' ' + good.classABCXYZ
          res1 = str.toString().toLowerCase().includes(element.toString().toLowerCase())
        })
        if (this.orderFilter === 'NotInStock' && good.ВРезерве === 0) res = false
        if (this.orderFilter === 'inStock' && good.ВРезерве !== 0) res = false
        if (this.selectedSchema !== good.СхемаОбеспечения_Key) res = false
        if (res === false || res1 === false || good.toOrder === '') res = false
        if ((good.Parent_Key !== this.folder1 && good.Parent_Key !== this.folder2) && (this.folder1 !== '00000000-0000-0000-0000-000000000000' && this.folder2 !== '00000000-0000-0000-0000-000000000000')) return false
        if (this.folder1 === '00000000-0000-0000-0000-000000000000' && this.folder2 !== '00000000-0000-0000-0000-000000000000') return false
        if (this.loading) return false
        return res
      })
    },
    element (good) {
      return good.Ref_Key
    },
    showpicture () {
      // console.log(this)
      return true
    }
  },
  watch: {
    selectedSchema () {
      this.calculateOrder()
    }
  },
  methods:
    {
      escCloseModal (e) {
        if (this.showModal && e.key === 'Escape') {
          this.showModal = false
        }
      },
      async getGoodABCXYZ (uid) {
        // console.log('getGoodABCXYZ ' + uid)
        let answer = await ApiService.getGoodABCXYZ(uid)
        this.goodABCXYZ = answer.data.value
        // console.log(this.goodABCXYZ)
        this.goodabc = 'UU'
        var cl = this.goodABCXYZ
        var abc = ''
        var xyz = ''
        cl.forEach((el) => {
          if (el.ТипКлассификации === 'ABC') abc = el.Класс
          if (el.ТипКлассификации === 'XYZ') xyz = el.Класс
        })
        if (abc === 'AКласс') this.goodabc = 'A'
        if (abc === 'BКласс') this.goodabc = 'B'
        if (abc === 'CКласс') this.goodabc = 'C'
        if (abc === 'НеКлассифицирован') this.goodabc = 'U'
        if (xyz === 'XКласс') this.goodabc += 'X'
        if (xyz === 'YКласс') this.goodabc += 'Y'
        if (xyz === 'ZКласс') this.goodabc += 'Z'
        if (xyz === 'НеКлассифицирован') this.goodabc += 'U'
      },
      async getGoodSales (uid) {
        console.log('getGoodSales ' + uid)
        this.getGoodABCXYZ(uid)
        this.getGoodReserves(uid)
        this.getGoodSelling(uid)
        this.salesavg30 = 0
        this.salesavg60 = 0
        this.goodstock = 0
        for (var i = 0; i < 8; i++) {
          var startDate = format(subDays(Date(), i * 7 + 7), 'YYYY-MM-DD')
          var endDate = format(subDays(Date(), i * 7), 'YYYY-MM-DD')
          const response = await ApiService.goodSalesByPeriod(uid, startDate, endDate)
          let data = response.data.value
          if (data.length > 0) {
            console.log(startDate, ' ', endDate)
            this.goodSales[7 - i] = data[0].ВНаличииExpense
            this.salesavg60 += data[0].ВНаличииExpense
            if (i < 4) this.salesavg30 += data[0].ВНаличииExpense
            this.goodBuy[7 - i] = data[0].ВНаличииReceipt
            this.goodStock[7 - i] = data[0].ВНаличииClosingBalance
          } else {
            this.goodSales[7 - i] = 0
            this.goodBuy[7 - i] = 0
            this.goodStock[7 - i] = 0
          }
        }
        // this.goodABCXYZ =
        this.goodstock = (this.goodStock[7])
        this.salesavg60 = Math.round(this.salesavg60 / 8)
        this.salesavg30 = Math.round(this.salesavg30 / 4)
        console.log('Класс: ' + this.goodabc)
        console.log('На складе: ' + this.goodstock)
        console.log('Отгружается  ' + this.goodSelling)
        console.log('В резервах: ' + this.reserved)
        console.log('Транзит: ' + this.goodshipment)
        console.log('Средние продажи в неделю за 2 месяца:' + this.salesavg60)
        console.log('Средние продажи за неделю за 1 месяц: ' + this.salesavg30)
        this.goodToOrder = this.salesavg30 - this.goodstock + this.reserved + this.goodSelling - this.goodshipment
        console.log('Заказать: ' + this.goodToOrder)
        this.orderComment = ''
        // console.log('Коэффициент: ' + coeff)
        // if (coeff !== 0) this.goodToOrder = Math.round(this.goodToOrder * coeff)
        if (this.salesavg60 < this.salesavg30) {
          this.orderComment += 'Продажи растут.'
        }
        if (this.salesavg60 > this.salesavg30) {
          this.orderComment += 'Продажи падают.'
        }
        if (this.goodToOrder === 0) {
          this.orderComment += ' Нет необходимости в заказе товара на неделю.'
        }
        if (this.goodToOrder > 0 && this.goodshipment === 0) {
          this.orderComment += ' Необходимо заказать ' + this.goodToOrder + 'шт на неделю.'
        }
        if (this.goodToOrder > 0 && this.goodshipment > 0) {
          this.orderComment += ' Товар едет, но его количество не покроет потребностей. Необходимо дозаказать еще ' + this.goodToOrder + 'шт на неделю.'
        }
        if (this.goodToOrder < 0 && this.goodstock >= this.salesavg30) {
          this.orderComment += ' На данный момент запасов достаточно, планируемый срок продажи остатков в неделях: ' + Math.abs(Math.round(this.goodToOrder / this.salesavg))
        }
        if (this.goodToOrder < 0 && this.goodstock < this.salesavg30 && this.goodshipment > this.salesavg30) {
          this.orderComment += ' На данный момент запасов на складе недостаточно, товар заказан и находится в транзите. С учетом транзита планируемый срок продажи товара после прихода на склад в неделях: ' + Math.abs(Math.round(this.goodToOrder / this.salesavg30))
        }
        this.barChartData = {
          labels: [format(subDays(Date(), 7 * 7), 'WW'), format(subDays(Date(), 6 * 7), 'WW'), format(subDays(Date(), 5 * 7), 'WW'), format(subDays(Date(), 4 * 7), 'WW'), format(subDays(Date(), 3 * 7), 'WW'), format(subDays(Date(), 2 * 7), 'WW'), format(subDays(Date(), 7), 'WW'), format(Date(), 'WW')],
          datasets: [
            {
              label: 'Продажи',
              backgroundColor: 'rgba(255, 0, 0, 0.3)',
              data: this.goodSales
            },
            {
              label: 'Остатки',
              backgroundColor: 'rgba(245, 192, 50, 0.3)',
              data: this.goodStock
            },
            {
              label: 'Покупки',
              backgroundColor: 'rgba(0, 255, 0, 0.3)',
              data: this.goodBuy
            }
          ]
        }
        this.showModal = true
      },
      async getGoodSelling (uid) {
        console.log('getGoodSelling')
        let answer = await ApiService.getGoodSelling(uid)
        var selling = answer.data.value
        // console.log(selling)
        this.goodSelling = 0
        selling.forEach((order) => {
          this.goodSelling += order.КОформлениюBalance
        })
      },
      async getGoodReserves (uid) {
        // console.log('getGoodReserves')
        let answer = await ApiService.getGoodReserves(uid)
        var reserves = answer.data.value
        this.reserved = 0
        if (reserves.length > 0) this.reserved = reserves[0].КоличествоИзЗаказовBalance + reserves[0].КоличествоНеобеспеченоBalance + reserves[0].КоличествоПодЗаказBalance
        else this.reserved = 0
      },
      async CreateSupplierOrder () {
        console.log('CreateSupplierOrder - ORDER')
        const created = await ApiService.createSupplierOrder()
        console.log(created)
        const response = await ApiService.getSupplierOrders()
        let data = response.data.value
        console.log(data)
        var goodsToOrder = this.filteredList
        console.log(goodsToOrder)
        var uid = data[0].Ref_Key
        var orderGoods = []
        goodsToOrder.forEach((good, index) => {
          if (good.toOrder > 0) {
            orderGoods[index] = {}
            orderGoods[index].LineNumber = index + 1
            orderGoods[index].КодСтроки = index + 1
            orderGoods[index].Ref_Key = uid
            orderGoods[index].Количество = good.toOrder
            orderGoods[index].КоличествоУпаковок = good.toOrder
            orderGoods[index].Номенклатура_Key = good.Ref_Key
            if (good.SebeS > 0) {
              orderGoods[index].Цена = Math.round((good.SebeS * 100 / 120) * 1.05 * 100) / 100
            } else orderGoods[index].Цена = 1
            orderGoods[index].Сумма = Math.round(good.toOrder * orderGoods[index].Цена * 100) / 100
            orderGoods[index].СуммаСНДС = orderGoods[index].Сумма * 1.2
            orderGoods[index].СтавкаНДС = 'НДС20'
            orderGoods[index].Склад_Key = '17631cba-e764-11e5-a13e-00e04d95380f'
          }
        })
        var dataVersion = data[0].DataVersion
        var jsonString = JSON.stringify(orderGoods)
        console.log(jsonString)
        const response1 = await ApiService.patchSupplierOrder(uid, jsonString, dataVersion)
        console.log(response1)
        this.$dialog.alert('Заказ сохранен в базе!').then(function (dialog) {
          // console.log('Sent')
        })
      },
      calculateInput (good, event) {
        good.changed = true
        this.lastedited = this.calculateid(good.Ref_Key)
        console.log('good.changed ' + good.changed)
        if (event.target.value < 1) {
          event.target.value = ''
          return ''
        } else {
          return event.target.value
        }
      },
      ChangeItem (good) {
        this.$emit('orderedItems')
      },
      calculateid (refkey) {
        return 'card-' + refkey
      },
      transit (good) {
        return 'Транзит к ' + this.$moment(good.DeliveryDate).format('DD-MM-YYYY')
      },
      async calculateOrder () {
        this.loading = true
        console.log('calculateOrder')
        this.goods.forEach((good) => {
          var res = this.reserves.filter(reserv => good.Ref_Key === reserv.Номенклатура_Key)
          // console.log(res)
          if (res.length > 0) good.ВРезерве = res[0].КоличествоИзЗаказовBalance + res[0].КоличествоНеобеспеченоBalance + res[0].КоличествоПодЗаказBalance
          else good.ВРезерве = 0
        })
        this.goods.forEach((good) => {
          var res = this.shipment.filter(reserv => good.Ref_Key === reserv.Номенклатура_Key)
          // console.log(res)
          if (res.length > 0) good.ВРезерве += res[0].КОформлениюBalance
        })
        this.goods.forEach((good) => {
          const sales60 = this.goodssales60.filter(sales => sales.Номенклатура_Key === good.Ref_Key)
          if (sales60.length > 0) {
            // console.log(good.Ref_Key + ' sales 180 ' + sales60[0].ВНаличииExpense)
            good.sales60 = sales60[0].ВНаличииExpense
            // sales = sales60[0].ВНаличииExpense
          } else good.sales60 = 0
          const sales30 = this.goodssales30.filter(sales => sales.Номенклатура_Key === good.Ref_Key)
          if (sales30.length > 0) {
            // console.log(good.Ref_Key + ' sales 14 ' + sales30[0].ВНаличииExpense)
            good.sales30 = Math.round(sales30[0].ВНаличииExpense)
            // sales = sales30[0].ВНаличииExpense
          } else good.sales30 = 0
          if (good.classABCXYZ === 'AX' || good.classABCXYZ === 'AY' || good.classABCXYZ === 'AZ') {
            good.toOrder = Math.round(good.sales30 / 4 - good.Stock + good.ВРезерве - good.DeliveryQty)
          } else {
            good.toOrder = Math.round(good.ВРезерве - good.Stock - good.DeliveryQty)
          }
          if (good.toOrder <= 0) good.toOrder = ''
          /*
          if (this.selectedSchema === good.СхемаОбеспечения_Key && this.selectedSchema !== '00000000-0000-0000-0000-000000000000') {
            if (this.selectedSchema === 'f0171508-6138-11e7-ac65-001dd8b723ef') {
              OrderedQty = Math.round(good.sales60 / 24 - good.Stock - good.DeliveryQty + good.ВРезерве)
            } else {
              OrderedQty = Math.round(good.sales60 / 6 - good.Stock - good.DeliveryQty + good.ВРезерве)
            }
            if (good.sales30 === -1 && good.sales60 > 0) Math.round(good.sales60 / 24 - good.Stock - good.DeliveryQty + good.ВРезерве)
            if (OrderedQty > 0) good.toOrder = OrderedQty
            else good.toOrder = ''
            // this.goodToOrder = this.salesavg - this.goodstock + this.reserved + this.goodSelling - this.goodshipment
          }
          if (this.selectedSchema === '00000000-0000-0000-0000-000000000000') {
            if (good.СхемаОбеспечения_Key === 'f0171508-6138-11e7-ac65-001dd8b723ef') {
              OrderedQty = 0
            } else if (good.StockS < good.sales60) {
              OrderedQty = Math.round(good.sales60 - good.StockS)
            }
            if (OrderedQty > 0) good.toOrder = OrderedQty
            else good.toOrder = ''
          }
          */
        })
        console.log('Calculation finished')
        // console.log(this.filteredList)
        this.loading = false
      },
      async getGoodsABCXYZ () {
        console.log('GoodsABCXYZ')
        let answer = await ApiService.getGoodsABCXYZ()
        this.goodsabc = answer.data.value
        this.goods.forEach((good) => {
          good.classABCXYZ = 'UU'
          var cl = this.goodsabc.filter(abc => abc.Номенклатура_Key === good.Ref_Key)
          var abc = ''
          var xyz = ''
          if (cl.length > 0) {
            cl.forEach((el) => {
              if (el.ТипКлассификации === 'ABC') abc = el.Класс
              if (el.ТипКлассификации === 'XYZ') xyz = el.Класс
            })
            if (abc === 'AКласс') good.classABCXYZ = 'A'
            if (abc === 'BКласс') good.classABCXYZ = 'B'
            if (abc === 'CКласс') good.classABCXYZ = 'C'
            if (abc === 'НеКлассифицирован') good.classABCXYZ = 'U'
            if (xyz === 'XКласс') good.classABCXYZ += 'X'
            if (xyz === 'YКласс') good.classABCXYZ += 'Y'
            if (xyz === 'ZКласс') good.classABCXYZ += 'Z'
            if (xyz === 'НеКлассифицирован') good.classABCXYZ += 'U'
            // console.log(good.classABCXYZ)
          }
        })
        this.calculateOrder()
      },
      async getGoodsSalesByPeriod60 () {
        console.log('GoodsSalesByPeriod60')
        var startDate = format(subDays(Date(), 56), 'YYYY-MM-DD')
        var endDate = format(subDays(Date(), -1), 'YYYY-MM-DD')
        let answer = await ApiService.goodsSalesByPeriod(startDate, endDate)
        this.goodssales60 = answer.data.value
        // console.log(answer.data.value)
      },
      async getGoodsSalesByPeriod30 () {
        console.log('GoodsSalesByPeriod30')
        var startDate = format(subDays(Date(), 28), 'YYYY-MM-DD')
        var endDate = format(subDays(Date(), -1), 'YYYY-MM-DD')
        let answer = await ApiService.goodsSalesByPeriod(startDate, endDate)
        this.goodssales30 = answer.data.value
        // console.log(answer.data.value)
      },
      async getGoodsReserves () {
        console.log('GoodsReserves')
        let answer = await ApiService.getGoodsReserves()
        this.reserves = answer.data.value
        // console.log(answer.data.value)
      },
      async getTransit () {
        console.log('Transit')
        let answer = await ApiService.getTransit()
        this.Transit = answer.data.value
        // console.log(answer.data.value)
      },
      async getGoodsToShipment () {
        console.log('GoodsToShipment')
        let answer = await ApiService.getGoodsToShipment()
        this.shipment = answer.data.value
        // console.log(answer.data.value)
      },
      searchFocus (str) {
        this.showOnce = false
        this.$refs.inp.focus()
        // console.log(str)
        this.search += str
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .btn-to-top {
    border-radius: 50%;
    padding: 1rem;
    padding-top: 0.9rem;
    padding-right: 1.1rem;
    padding-bottom: 0.9rem;
    padding-left: 1.1rem;
  }
.btn.btn-nav {
    padding: 0.1rem 1.0rem;
    font-size: 0.64rem;
  }
.badge-pill {
    border-radius: 10rem;
    padding-right: 0.6em;
    margin-top: 0.6em;
  }
.form-control:focus {
    border:0px
    }
.form-control {
    height:auto
    }
.order-btn {
    margin-top: 0.375rem;
    margin-left: 0rem;
    }
.search {
    border: 1px solid #1e282d;
    }
.stock {
    border: 1px solid #007e33;
    }
.miss {
    border: 1px solid #d50000;
    }
 .supplier {
    border: 1px solid #9933cc;
    }
.transit {
    border: 1px solid #ff8800;
    }
.w-120 {
    width: 120px!important;
}
.w-50 {
    width: 60px!important;
}
.inp {
    font-size: 1.5rem;
}
.md-form {
    position: relative;
    margin-top: 0rem;
    margin-bottom: 0rem;
}
.cascading-admin-card {
  padding-left: 5px;
  padding-right: 5px;
}
.m-0 {
    margin: 0.4rem!important;
}
.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
}
.cascading-admin-card .admin-up .fa {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 20px 0 rgba(0, 0, 0, 0.19);
}
.cascading-admin-card .admin-up .fa {
  padding: 1.7rem;
  font-size: 2rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
}
.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}
.admin-up .data p {
  color: #999999;
  font-size: 12px;
}
.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}
  .card-text {
  font-size: 16px;
  opacity: 1.0;
  margin-bottom: 0;
  margin-left: 1rem;
  font-weight: 300;
}
.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order.vue